import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import TaskPayload from '../schemas/TaskPayload'
import ajax from '@get-bridge/learn-legacy-shared/dist/utils/ajax'
import formatTaskForApi from 'formatTaskForApi'
import parseTask from 'parseTask'

export default DataRequest({
  schema: TaskPayload,

  perform(task) {
    const data = formatTaskForApi(task)

    return ajax({
      url: '/api/learner/perform_tasks',
      type: 'POST',
      data
    })
  },

  parse(normalize, payload) {
    return payload.tasks.map(normalize)
      .map(parseTask)[0]
  }
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/tasks/data_requests/createTask.js